import usePermission from 'hooks/usePermission'

export function AllowPermission({ children, permission }) {
  const { hasPermission } = usePermission()

  if (hasPermission(permission)) {
    return children
  }

  return null
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/shared/components/AllowPermission/index.js